import Button from '../base/Button';

export default function Hero() {
  return (
    <section id="home" className="min-h-screen flex items-center bg-white relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/43e4924cc7dd0ac0e289a79b37cc8e2d.png')`,
          filter: 'blur(3px)'
        }}
      >
        <div className="absolute inset-0 bg-black/25 md:bg-black/35"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-5 gap-12 items-center min-h-screen py-20">
          {/* Content - Left Side */}
          <div className="lg:col-span-2 text-left md:pt-24">
            <h1 className="hero-title text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight text-contrast">
              <strong>Dr. Luiz Renato Kreb</strong>
            </h1>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-[#6B2432] mb-6 text-contrast">
              Sua Melhor Versão Começa Aqui
            </h2>
            <p className="text-lg md:text-xl text-white mb-8 leading-relaxed text-contrast">
              Cirurgia Buco-Maxilo-Facial e Harmonização Orofacial com Excelência
            </p>
            
            {/* Badges */}
            <div className="flex flex-wrap gap-4 mb-8">
              <div className="bg-white/90 text-[#6B2432] px-4 py-2 rounded-full text-sm font-medium">
                CRO 25.239 - PR
              </div>
              <div className="bg-white/90 text-[#6B2432] px-4 py-2 rounded-full text-sm font-medium">
                Intercâmbio Madrid
              </div>
              <div className="bg-white/90 text-[#6B2432] px-4 py-2 rounded-full text-sm font-medium">
                3 Pós-Graduações
              </div>
            </div>

            <Button 
              href="https://wa.me/5544999297166"
              size="lg"
              icon={<i className="ri-whatsapp-line text-xl"></i>}
              className="mobile-button text-xl px-10 py-5"
            >
              Agendar Consulta com Dr. Luiz
            </Button>
          </div>

          {/* Image Space - Right Side */}
          <div className="lg:col-span-3 hidden lg:block">
            {/* Image is handled by background */}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-white"></i>
      </div>
    </section>
  );
}
